import { Injectable } from '@angular/core';
import {ApiRouteConfig} from "../../../config/api.route.config";
import {HttpClient} from "@angular/common/http";
import {BuildingStructure} from "./model/building-structure";

@Injectable()
export class StructureService {

  constructor(
      private readonly api: ApiRouteConfig,
      private readonly http: HttpClient,
  ) { }

  public detailsFor(structureId: number) {
    return this.http.get<BuildingStructure>(
        this.api.getRouteWithInjectedParams(this.api.STRUCTURE_DETAILS, [structureId])
    );
  }
  public childrenFor(structureId: number) {
    return this.http.get<BuildingStructure[]>(
        this.api.getRouteWithInjectedParams(this.api.STRUCTURE_CHILDREN, [structureId])
    );
  }
}
